var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { Heading, Text } from '../../Typography';
import { withDataTableContext } from '../DataTableContextConsumer';
import Link from '../../Link';
import './DataTableEmptyColumnsMessage.scss';
var DataTableEmptyColumnsMessage = /** @class */ (function (_super) {
    __extends(DataTableEmptyColumnsMessage, _super);
    function DataTableEmptyColumnsMessage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onOptionsClick = function () {
            var setContextState = _this.props.setContextState;
            setContextState({
                isCustomiseModalOpen: true,
            });
        };
        return _this;
    }
    DataTableEmptyColumnsMessage.prototype.render = function () {
        return (React.createElement("div", { className: "elmo-datatable__empty-columns" },
            React.createElement(Heading, null, "The Parthenon has collapsed."),
            React.createElement(Text, null,
                "We recommend you",
                ' ',
                React.createElement(Link, { url: "#", onClick: this.onOptionsClick }, "redeem yourself"),
                ' ',
                "Ares before Athena finds out.")));
    };
    return DataTableEmptyColumnsMessage;
}(React.Component));
export default withDataTableContext(DataTableEmptyColumnsMessage);
